import { WechatController } from '@/services/request.service';
import config from '@/school.config';
const wx = require('weixin-js-sdk');
const env: string = process.env.VUE_APP_ENV as string;

export const initWechat = async (link: string) => {
  const res = await WechatController.getSgin(link);
  const { timestamp, nonceStr, sign } = res.data;
  const id = 'ks';
  wx.config({
    debug: process.env.VUE_APP_ENV === 'production' ? false : true, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
    appId: config[id][env].appid, // 必填，公众号的唯一标识
    timestamp, // 必填，生成签名的时间戳
    nonceStr, // 必填，生成签名的随机串
    signature: sign, // 必填，签名
    jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData'], // 必填，需要使用的JS接口列表
  });
};

export const wechatReady = (title: string, desc: string, icon: any, link: string) => {
  wx.ready(() => {
    // 需在用户可能点击分享按钮前就先调用
    wx.updateAppMessageShareData({
      title, // 分享标题
      desc, // 分享描述
      link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
      imgUrl: icon, // 分享图标
      success() {},
    });
    wx.updateTimelineShareData({
      title, // 分享标题
      link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
      imgUrl: icon, // 分享图标
      success() {},
    });
  });
};
